import type { NextRouter } from '@/utils/types'

import { WEBSITE_URL } from './constants'

/**
 * Takes a list of query parameters, setting the ones that have string values
 * and deleting the ones that have null values. Returns the new url.
 */
export function updateQueryParams({
  params,
  router,
}: {
  params: { key: string; value: string | null }[]
  router: NextRouter
}): string {
  const urlSearchParams = new URLSearchParams(Object.entries(router.query) as string[][])
  params.forEach(({ key, value }) => {
    if (value == null) {
      urlSearchParams.delete(key)
    } else {
      urlSearchParams.set(key, value)
    }
  })
  return `${router.pathname}?${urlSearchParams.toString()}`
}

export function routerMatchesUrl(router: NextRouter, url: string): boolean {
  return new URL(router.asPath, WEBSITE_URL).href === new URL(url, WEBSITE_URL).href
}

export function addReferralCodeIfNotPresent(url: string, referralCode: string): string {
  const urlObj = new URL(url)
  const queryParams = new URLSearchParams(urlObj.search)

  if (!queryParams.has('ref')) {
    queryParams.set('ref', encodeURIComponent(referralCode).toLowerCase())
    urlObj.search = queryParams.toString()
  }

  return urlObj.toString()
}
